import { createSlice } from "@reduxjs/toolkit";
import { fetchMyProjects } from "../actions/myProjectAction";

const initialState = {
  myProjects: [],
  loading: false,
  error: null,
};

const myProjectSlice = createSlice({
  name: "myProjects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.myProjects = action.payload?.data || [];
      })
      .addCase(fetchMyProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.myProjects = [];
      });
  },
});

export default myProjectSlice.reducer;
